import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';

const ServicesPage = () => {
  const services = [
    {
      title: 'RovoConnect', 
      path: '/rovoconnect',
      description: 'RovoConnect shatters data silos by unifying diverse factory equipment—from Robots to multi-protocol PLCs—into a single, real-time intelligence stream. Built on robust, scalable edge computing architecture, it transforms raw machine signatures into actionable predictive insights, slashing unplanned downtime and optimizing Overall Equipment Effectiveness (OEE) without the need for costly enterprise infrastructure.', // The Description
      image: '/images/projects/rovovision.png', 
      features: [
        'Universal Industrial Connectivity',
        'Sovereign Edge Architecture ',
        'AI-Driven Predictive Maintenance',
        'Unified Operations Command'
      ]
    

    },
    {
      title: 'RovoVision',
       path: '/rovovision',
      description: 'RovoVision upgrades your existing camera infrastructure into a proactive AI co-pilot for the production floor. By processing video feeds at the edge with zero latency, it automates safety protocols, quantifies Standard Operating Procedure (SOP) adherence, and delivers irrefutable compliance data—turning raw footage into competitive factory intelligence without adding headcount.', // The Description
      image: '/images/projects/rovovisionn(2).png', 
      features: [
        'Seamless Edge Retrofit',
        'Proactive Safety Assurance',
        'Digital SOP Verification',
        'Automated Performance Scorecards'
      ]
    },
    {
      title: 'RovoPeople', 
       path: '/rovopepole',
      description: 'RovoPeople is an all-in-one HR software that centralizes employee data, attendance, payroll, and performance tracking. It helps HR teams manage the entire employee lifecycle efficiently, from onboarding to salary management.', // The Description
      image: '/images/projects/why.jpeg', 
      features: [
        'Automated Attendance',
        'Integrated Payroll',
        'Employee Self-Service',
        'Employee Self-Service'
      ]
    },

    {
      title: 'Visitech',
       path: '/visitech',
      description: 'Smart visitor management system with digital check-in, badge printing, and real-time tracking for enhanced security.',
      image: '/images/projects/visitech rovo.png',
      features: ['Digital check-in', 'Badge printing', 'Visitor tracking', 'Security alerts']
    },


    
    {
      title: 'Andon System',
       path: '/Andon',
      description: 'Real-time visual management system that alerts teams to production issues, enabling quick response and minimizing downtime.',
      image: '/images/projects/services.png',
      features: ['Real-time alerts', 'Visual dashboards', 'Production monitoring', 'Issue tracking']
    },
   {
      title: 'User Identification',
       path: '/User',
      description: 'Advanced biometric and RFID-based user identification systems for secure access control and workforce tracking.',
      image: '/images/projects/serviesss.png',
      features: ['Biometric authentication', 'RFID integration', 'Access control', 'Time tracking']
    },
    {
      title: 'OEE Dashboard',
       path: '/OEE',
      description: 'Comprehensive Overall Equipment Effectiveness dashboard providing real-time insights into production performance and efficiency.',
      image: '/images/projects/oee dash.png',
      features: ['Performance metrics', 'Real-time analytics', 'Downtime tracking', 'Efficiency reports']
    },
    
    // START: ADDED ROVOCONNECT PRODUCT HERE (5th Item)
    
    // {
    //   title: 'RovoConnect', // The Title
    //   description: 'RovoConnect provides real-time robot connectivity, Preventive maintenance, and unified dashboards to optimize manufacturing efficiency.', // The Description
    //   image: '/images/projects/rovoconnect.png', // **NOTE: Update this path to your actual image file**
    //   features: [
    //     'Universal TCP/IP Robot Connectivity',
    //     'Real-Time Data Streaming ',
    //     'AI-Powered Predictive Maintenance',
    //     'Unified Multi-Robot Dashboard'
    //   ]
    // }
    // END: ADDED ROVOCONNECT PRODUCT
  ];

  return (
    <div id="main-wrapper">
      <Header />
      <div id="content" role="main">
        {/* Hero Section */}
        <section
          className="hero-wrap"
          style={{
            position: 'relative',
            overflow: 'hidden',
            minHeight: '60vh',
            display: 'flex',
            alignItems: 'center',
            backgroundImage: "url('/images/projects/Technology-v2.jpg')",
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            // optional: overlay gradient on top of image

          }}
        >
          <div className="container" style={{ position: 'relative', zIndex: 2, paddingTop: '70px' }}>
            <div className="row">
              <div className="col-12 text-center text-white">
                <h1 className="text-16 font-weight-600 mb-3 text-white    ">Our Product</h1>
                <p className="lead text-white-100 mb-0">Comprehensive IoT & Automation Solutions Tailored to Your Needs</p>
              </div>
            </div>
          </div>
        </section>


        {/* Services Overview */}


{/* Services Overview */}
<section className="section bg-white ">
  <div className="container">
    <div className="row">
      <div className="col-lg-8 mx-auto text-center mb-5">
        <h2 className="font-weight-600 mb-3">What We Offer</h2>
        <hr className="heading-separator-line border-primary border-2 d-block mx-auto" />
        <p className="text-3">We provide cutting-edge solutions that transform your business operations and drive digital innovation</p>
      </div>
    </div>

   <div className="row">
  {services.map((service, index) => (
    <div key={index} className="col-12 col-md-6 mb-4">

      <Link
        to={service.path}
        style={{ textDecoration: 'none', color: 'inherit' }}
      >
        <div className="bg-white rounded shadow h-100 overflow-hidden">
          <img
            src={service.image}
            alt={service.title}
            className="img-fluid"
            style={{ width: "100%", height: "230px", objectFit: "cover" }}
          />

          <div className="p-4">
            <h4 className="font-weight-700 mb-4">{service.title}</h4>
            <p className="text-3 mb-3">{service.description}</p>

            <ul className="list-unstyled mb-0">
              {service.features.map((feature, idx) => (
                <li key={idx} className="mb-2">
                  <i className="fas fa-check text-primary mr-2"></i>
                  <span className="text-3">{feature}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Link>

    </div>
  ))}
</div>
  </div>
</section>
        {/* Why Choose Us */}
        <section
          className="section"
          style={{
            marginTop: '-80px',
            backgroundColor: '#dcdfe2ff',
            color: 'white'
          }} // 👈 adjust value as needed
        >
          <div className="container">
            <div className="row">
              {/* Header content like Why Choose RovoAutomation */}
            </div>

            <div className="row">

              {/* Custom Solutions */}
              <div className="col-md-6 col-lg-3 mb-4">
                <div className="text-center bg-white p-4 rounded shadow-sm h-100">
                  <div className="text-primary mb-3">
                    <i className="fas fa-cogs fa-2x"></i>
                  </div>
                  <h5 className="font-weight-600 mb-2">Custom Solutions</h5>
                  <p className="text-muted mb-0 font-weight-700">
                    Tailored to your specific business needs and requirements
                  </p>
                </div>
              </div>

              {/* Expert Team */}
              <div className="col-md-6 col-lg-3 mb-4">
                <div className="text-center bg-white p-4 rounded shadow-sm h-100">
                  <div className="text-primary mb-3">
                    <i className="fas fa-users-cog fa-2x"></i>
                  </div>
                  <h5 className="font-weight-600 mb-2">Expert Team</h5>
                  <p className="text-muted mb-0 font-weight-700">
                    Experienced professionals with deep industry knowledge
                  </p>
                </div>
              </div>

              {/* 24/7 Support */}
              <div className="col-md-6 col-lg-3 mb-4">
                <div className="text-center bg-white p-4 rounded shadow-sm h-100">
                  <div className="text-primary mb-3">
                    <i className="fas fa-headset fa-2x"></i>
                  </div>
                  <h5 className="font-weight-600 mb-2">24/7 Support</h5>
                  <p className="text-muted mb-0 font-weight-700 ">
                    Round-the-clock technical support and maintenance
                  </p>
                </div>
              </div>

              {/* Proven Results */}
              <div className="col-md-6 col-lg-3 mb-4">
                <div className="text-center bg-white p-4 rounded shadow-sm h-100">
                  <div className="text-primary mb-3">
                    <i className="fas fa-chart-line fa-2x"></i>
                  </div>
                  <h5 className="font-weight-600 mb-2">Proven Results</h5>
                  <p className="text-muted mb-0 font-weight-700 ">
                    Track record of successful implementations
                  </p>
                </div>
              </div>

            </div>
          </div>
        </section>

        {/* Process Section */}
        <section className="section bg-white py-5">
          <div className="container">
            {/* Process Header - Why Choose RovoAutomation se matching styling */}
            <div className="row">
              <div className="col-lg-8 mx-auto text-center mb-5">
                {/* Header text color default/dark rakha hai */}
                <h2 className="font-weight-bold mb-3">Our Process</h2>
                {/* Separator line sirf border-primary color use kar rahi hai */}
                <hr className="heading-separator-line border-primary border-3 d-block mx-auto" style={{ width: '60px' }} />
                <p className=" text-4">A systematic approach to delivering excellence</p>
              </div>
            </div>

            {/* Process Steps Row */}
            <div className="row justify-content-center position-relative">

              {/* Progress Line - Primary Color line use ho rahi hai */}
              <div className="process-line-primary d-none d-lg-block"></div>

              {/* Step 1: Discovery */}
              <div className="col-md-6 col-lg-3 mb-4 process-step">
                <div className="card border-0 shadow-sm h-100 text-center p-4">
                  {/* Icon Box sirf Primary color use kar raha hai */}
                  <div className="icon-box bg-light-primary text-primary rounded-circle d-inline-flex align-items-center justify-content-center mb-4 mx-auto" style={{ width: '70px', height: '70px' }}>
                    <i className="fas fa-search fa-2x"></i>
                  </div>
                  <h5 className="font-weight-bold mb-2 text-dark">Discovery</h5>
                  <p className="text-3 mb-0 small">Understanding your business needs and challenges</p>
                </div>
              </div>

              {/* Step 2: Planning */}
              <div className="col-md-6 col-lg-3 mb-4 process-step">
                <div className="card border-0 shadow-sm h-100 text-center p-4">
                  <div className="icon-box bg-light-primary text-primary rounded-circle d-inline-flex align-items-center justify-content-center mb-4 mx-auto" style={{ width: '70px', height: '70px' }}>
                    <i className="fas fa-project-diagram fa-2x"></i>
                  </div>
                  <h5 className="font-weight-bold mb-2 text-dark">Planning</h5>
                  <p className="text-3 mb-0 small">Designing the optimal solution architecture</p>
                </div>
              </div>

              {/* Step 3: Implementation */}
              <div className="col-md-6 col-lg-3 mb-4 process-step">
                <div className="card border-0 shadow-sm h-100 text-center p-4">
                  <div className="icon-box bg-light-primary text-primary rounded-circle d-inline-flex align-items-center justify-content-center mb-4 mx-auto" style={{ width: '70px', height: '70px' }}>
                    <i className="fas fa-rocket fa-2x"></i>
                  </div>
                  <h5 className="font-weight-bold mb-2 text-dark">Implementation</h5>
                  <p className="text-3 mb-0 small">Deploying and integrating the solution</p>
                </div>
              </div>

              {/* Step 4: Support */}
              <div className="col-md-6 col-lg-3 mb-4 process-step">
                <div className="card border-0 shadow-sm h-100 text-center p-4">
                  <div className="icon-box bg-light-primary text-primary rounded-circle d-inline-flex align-items-center justify-content-center mb-4 mx-auto" style={{ width: '70px', height: '70px' }}>
                    <i className="fas fa-headset fa-2x"></i>
                  </div>
                  <h5 className="font-weight-bold mb-2 text-dark">Support</h5>
                  <p className="text-3 mb-0 small">Ongoing maintenance and optimization</p>
                </div>
              </div>

            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section
          className="section text-white"
          style={{
            backgroundImage: "url('/images/projects/pf.jpg')", 
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            position: 'relative',
            zIndex: 1,
          }}>
          <div
            className="container"
            style={{
              position: 'relative',
              zIndex: 2,
            }}
          >
            <div className="row align-items-center">
              <div className="col-lg-8 mb-4 mb-lg-0">
                <h3 className="font-weight-600 mb-2 text-white">Ready to Get Started?</h3>
                <p className="lead mb-0">Let’s find the perfect solution tailored to your needs.</p>
              </div>
              <div className="col-lg-4 text-lg-right">
                <a href="/contact" className="btn btn-light btn-lg rounded-pill">Contact Us Today</a>
              </div>
            </div>
          </div>

         
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0,0,0,0.4)',
              zIndex: 0,
            }}
          ></div>
        </section>

      </div>
      <Footer />
    </div>
  );
};

export default ServicesPage;